require("jquery");
require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("trix");
require("@rails/actiontext");

const bootstrap = require("bootstrap");

import "../stylesheets/app";

require("../components/direct_upload");

require.context("../images", true);

document.addEventListener("turbolinks:load", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((tooltipTriggerEl) => {
    bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl, {
      html: true
    });
  });

  const noReasonSelect = document.querySelector("#noModal select[name='reason_for_no']");
  const noReasonDetails = document.querySelector("#noModal [data-no-reason-details]");

  if (noReasonSelect && noReasonDetails) {
    const toggleNoReasonDetails = () => {
      noReasonDetails.classList.toggle("d-none", noReasonSelect.value !== "other");
    };

    noReasonSelect.addEventListener("change", toggleNoReasonDetails);
    toggleNoReasonDetails();
  }
});
